import React, {Component} from "react";
import {TagIcon} from '../Icons';
import './navbar.scss';

interface NavBarProps {
  tag?: number;
  title?: string;
  supTitle?: string;
  actionBtnTitle?: string;
  backBtnTitle?: string;
  backBtnClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  actionBtnClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
};


class NavBar extends Component<NavBarProps> {
  render () {
    return (
      <>
        <nav className="navbar" >
        <div>
          {this.props.backBtnTitle &&
            <button className="navbar_back-button" onClick={this.props.backBtnClick} >{this.props.backBtnTitle}</button>
          }
          </div>
        	<div className="navbar_title">
            {this.props.supTitle &&
              <span className="navbar_small-title">{this.props.supTitle}</span>
            }
            {this.props.title &&
        		  <span className="navbar_main-title">{this.props.title}</span>
            }
            {this.props.tag &&
              <>
                <TagIcon fill="#FFDD57" className="tag-icon" />
                <span className="navbar_tag">{this.props.tag}</span>
              </>
            }
        	</div>
          <div>
          {this.props.actionBtnTitle &&
            <button className="navbar_action-button" onClick={this.props.actionBtnClick} >{this.props.actionBtnTitle}</button>
          }
        	 </div>
        </nav>
      </>
     )
  }

}

export default NavBar;
